import { JsonSchemaValidator } from "@common/json-schema-validator";
import {
  NoticeCreatedAt,
  NoticeData,
  NoticeEntityId,
  NoticeKind
} from "../interface";
import {
  noticeCreatedAt,
  noticeData,
  noticeEntityId,
  noticeKind
} from "../schema";

export class NoticeCreate2Cmd {
  private static configValidation = JsonSchemaValidator.compile(
    NoticeCreate2Cmd.configValidationSchema()
  );

  readonly value: NoticeCreate2;

  constructor(value: NoticeCreate2) {
    this.value = JsonSchemaValidator.assert(
      NoticeCreate2Cmd.configValidation,
      value
    );
  }

  toJSON() {
    return this.value;
  }

  private static configValidationSchema() {
    return {
      type: "object",
      required: ["id", "kind", "data", "createdAt"],
      properties: {
        id: noticeEntityId,
        kind: noticeKind,
        data: noticeData,
        createdAt: noticeCreatedAt
      },
      additionalProperties: false
    };
  }
}

interface NoticeCreate2 {
  id: NoticeEntityId;
  kind: NoticeKind;
  data: NoticeData;
  createdAt: NoticeCreatedAt;
}
